import Card from '@mui/material/Card'
import styled from '@mui/material/styles/styled'

export const CampaignTrackingCard = styled(Card, {
  name: 'CampaignTrackingCard',
  slot: 'Root',
  skipSx: true,
})(({ theme }) => ({
  display: 'block',
  alignItems: 'center',
  width: '360px',
  height: '100%',
  marginBottom: theme.spacing(2),
  justifyContent: 'space-between',
  padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
}))
